import { useSeoFormActions } from "@rf/property/module/components/property-form/store/slices/SeoFormSlice";
import { useValidateMinimalFieldRequired } from "./useValidateMinimalFieldRequired";
import { useValidateSeoRequiere } from "./useValidateSeoRequiere";
import useValidateSeoFieldHasValue from "./useValidateSeoFieldHasValue";
import { CPropertyFormKeys } from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";

const useSeoTitleHelper = () => {
  const { validateMinimalRequiredField } = useValidateMinimalFieldRequired();
  const { generateTitle, isLoadingGenerateTitle, isLoadingTranslateSection } =
    useSeoFormActions();
  const { validate } = useValidateSeoRequiere();

  const { evaluateAndConfirmFieldReplacement: checkFields } =
    useValidateSeoFieldHasValue([
      CPropertyFormKeys.seo_title_en_property,
      CPropertyFormKeys.seo_title_es_property
    ]);

  const onValidate = async () => {
    if (!validateMinimalRequiredField()) {
      return;
    }

    const _v = await validate();
    if (_v) {
      if (await checkFields()) {
        generateTitle();
      }
    }
  };

  return {
    generateTitle,
    onValidate,
    isLoadingGenerateTitle,
    isLoadingTranslateSection
  };
};

export default useSeoTitleHelper;
